module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_3.9c31cc5f.png";